import React, { Component } from 'react';
import '../../css/style.css';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css'; 
class LandingTimeline extends Component {
    
    render() {
      return (
        <section className="timeline-section">
          <VerticalTimeline>
            <VerticalTimelineElement
              className="vertical-timeline-element--work vertical-timeline-element--split"
              date={
                <div className="awards-container">
                  <div className="award-item align-items-start">
                    <div className="clients border d-flex align-items-center justify-content-center">
                      <img src="./assets/img/homepage/NIH-Logo.webp" className="award-bullet" alt="NIH Logo" /></div>
                    <span><strong><a href="https://drive.google.com/file/d/1N-DDV6iD5Ve7ZQiadiHcA20vA4vmHKsn/view" target="_blank" rel="noopener noreferrer">NIH: Certificate of Appreciation</a> </strong> for outstanding collaboration, dedication, and commitment to NLM Mission</span>
                  </div>
                  <div className="award-item align-items-start">
                    <div className="clients border d-flex align-items-center justify-content-center">
                      <img src="./assets/img/homepage/cssda-award.webp" className="award-bullet" alt="CSSDA Award" /></div>
                    <span style={{ paddingTop: '0.5rem' }}><strong>CSSDA Special Kudos:</strong>
                      <ul style={{ margin: '0.25rem 0', paddingLeft: '1.25rem' }}>
                        <li style={{ paddingBottom: '0.25rem' }}><a href="https://www.cssdesignawards.com/sites/national-grid-co2-calculator/48602/" target="_blank" rel="noopener noreferrer">National Grid CO2 Calculator</a></li>
                      </ul></span>
                  </div>
                  <div className="award-item align-items-start">
                    <div className="clients border d-flex align-items-center justify-content-center">
                      <img src="./assets/img/homepage/hermes-logo.webp" className="award-bullet" alt="Hermes Award" /></div>
                    <span style={{ paddingTop: '0.5rem' }}><strong>Hermes Creative Award:</strong>
                      <ul style={{ margin: '0.25rem 0', paddingLeft: '1.25rem' }}>
                        <li style={{ paddingBottom: '0.25rem' }}><a href="https://enter.amcpros.com/hermes/entry/nyc-accelerator-building-energy-snapshot/" target="_blank" rel="noopener noreferrer">NYC Accelerator Building Energy Snapshot</a></li>
                        <li style={{ paddingBottom: '0.25rem' }}><a href="https://enter.amcpros.com/hermes/entry/building-a-better-nyc-with-energy-upgrades/" target="_blank" rel="noopener noreferrer">Building a Better NYC with Energy Update</a></li>
                        <li style={{ paddingBottom: '0.25rem' }}><a href="https://enter.amcpros.com/hermes/entry/bges-the-efficient-home-magazine-8/" target="_blank" rel="noopener noreferrer">BGE's The Efficient Home magazine</a></li>
                        <li style={{ paddingBottom: '0.25rem' }}><a href="https://enter.amcpros.com/hermes/entry/being-smart-runs-in-the-family/" target="_blank" rel="noopener noreferrer">CE Being Smart Runs in the Family</a></li>
                      </ul></span>
                  </div>
                  <div className="award-item align-items-start">
                    <div className="clients border d-flex align-items-center justify-content-center">
                      <img src="./assets/img/homepage/marcom-award.webp" className="award-bullet" alt="Marcom Award" /></div>
                    <span style={{ paddingTop: '0.5rem' }}><strong>Marcom Creative Award:</strong>
                      <ul style={{ margin: '0.25rem 0', paddingLeft: '1.25rem' }}>
                        <li style={{ paddingBottom: '0.25rem' }}><a href="https://enter.amcpros.com/marcom/entry/the-efficient-home-magazine-issue-2-6/" target="_blank" rel="noopener noreferrer">The Efficient Home Magazine</a></li>
                        <li style={{ paddingBottom: '0.25rem' }}><a href="https://enter.amcpros.com/marcom/entry/washington-gas-energy-efficiency-microsite/" target="_blank" rel="noopener noreferrer">Washington Gas Microsite</a></li>
                      </ul></span>
                  </div>
                </div>
              }
              iconStyle={{ background: '#ffffff', color: '#000' }}
              icon={<img src="./assets/img/homepage/icf-next-logo.webp" className="timeline-logo icf-next-logo" />}
            >


              <div className="vertical-timeline-element-content-inner">
                <h3 className="vertical-timeline-element-title">Interaction Design Manager,<br /> Emerging Technologies</h3>
                <h4 className="vertical-timeline-element-subtitle"><a href="https://www.icf.com/next" target="_blank" rel="noopener noreferrer">ICF Next</a></h4>

                <p className="timeline-job-description">
                  Lead the Interaction Design team delivering UX, UI, and front-end design solutions across government and commercial platforms. Partner with product and engineering to drive end-to-end experience design, from concept through delivery, while advancing design systems, accessibility, and emerging AI-enabled workflows. Mentor designers, set quality standards, and ensure consistent, scalable execution across projects.
                </p>
              </div>


            </VerticalTimelineElement>


            <VerticalTimelineElement
              className="vertical-timeline-element--work"

              iconStyle={{ background: '#ffffff', color: '#000' }}
              icon={<img src="./assets/img/homepage/icf_logo.webp" className="timeline-logo" />}
            >
              <h3 className="vertical-timeline-element-title">Senior Interaction Designer</h3>
              <h4 className="vertical-timeline-element-subtitle"><a href="https://www.icf.com/" target="_blank" rel="noopener noreferrer">ICF</a></h4>
              <p className="timeline-job-description">
                Specialized in designing and developing multi-platform web and mobile applications for U.S government agencies and large utility cooperatives.
              </p>

              <div className="awards-container">
                <div className="award-item align-items-start">
                  <div className="clients border d-flex align-items-center justify-content-center">
                    <img src="./assets/img/homepage/pmi-logo.webp" className="award-bullet" alt="PMI Logo" /></div>
                  <span style={{ paddingTop: '0.5rem' }}><strong><a href="https://drive.google.com/file/d/1EzsdjtgvqKSWxY3hRjcIcHm-F0C_CeKr/view?usp=sharing" target="_blank" rel="noopener noreferrer">Project Management Professional (PMP)</a> </strong></span>
                </div>
                <div className="award-item align-items-start">
                  <div className="clients border d-flex align-items-center justify-content-center">
                    <img src="./assets/img/homepage/salesforce-logo.webp" className="award-bullet" alt="Salesforce Logo" /></div>
                  <span style={{ paddingTop: '0.5rem' }}><strong><a href="https://drive.google.com/file/d/16xmDWJy5ExXgAr4G0WaTVLO2IdURePLv/view?usp=sharing" target="_blank" rel="noopener noreferrer">Salesforce Certified UX Designer</a> </strong></span>
                </div>
                <div className="award-item align-items-start">
                  <div className="clients border d-flex align-items-center justify-content-center">
                    <img src="./assets/img/homepage/serviceNow.webp" className="award-bullet" alt="ServiceNow Logo" /></div>
                  <span style={{ paddingTop: '0.5rem' }}><strong><a href="https://drive.google.com/file/d/181KVP6dZR0tldCxrckLPOW93bUoTBAcl/view?usp=sharing" target="_blank" rel="noopener noreferrer">ServiceNow Certified System Administrator</a> </strong></span>
                </div>
                <div className="award-item align-items-start">
                  <div className="clients border d-flex align-items-center justify-content-center">
                    <img src="./assets/img/homepage/icf_logo.webp" className="award-bullet" alt="ICF Logo" /></div>
                  <span style={{ paddingTop: '0.5rem' }}><strong>ICF Recognition:</strong>
                    <ul style={{ margin: '0.25rem 0', paddingLeft: '1.25rem' }}>
                      <li style={{ paddingBottom: '0.25rem' }}><a href="https://drive.google.com/file/d/1zTEryMRGQ-PsGWq423TEBPJLGz72LxQH/view" target="_blank" rel="noopener noreferrer">Synergy Award</a></li>
                      <li style={{ paddingBottom: '0.25rem' }}><a href="https://drive.google.com/file/d/1NyOgUEqZY9nTi3v6Autg8ufcADBsnNBA/view" target="_blank" rel="noopener noreferrer">Team Work in Action Award</a></li>
                    </ul></span>
                </div>
              </div>

            </VerticalTimelineElement>


            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="2015"
              iconStyle={{ background: '#ffffff', color: '#000' }}
              icon={<img src="./assets/img/homepage/amazon-logo.webp" className="timeline-logo" />}
            >
              <h3 className="vertical-timeline-element-title">UX Design Intern</h3>
              <h4 className="vertical-timeline-element-subtitle">Amazon</h4>
              <p className="timeline-job-description pb-3">
                Helped design Amazon's Homepage, both for mobile and desktop.Brainstormed, prototyped and architected a scalable system for Amazon's mobile Homepage
              </p>
              <blockquote>
                <p className="timeline-blockquote">Kaipeng is a thoughtful UX designer who is as comfortable in the deep-end thinking
                  through platform patterns as he is on the practical front-end implementation and
                  prototyping side of things. His ideas are often refreshing, out of the box concepts that
                  have a laser focus on customer benefit.</p>
                <span>—Ryan LaBoube, Senior UX Lead, Global Navigation at Amazon.com</span>
              </blockquote>

            </VerticalTimelineElement>




            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="2014 - 2016"
              iconStyle={{ background: '#ffffff', color: '#000' }}
              icon={<img src="./assets/img/homepage/um-logo.webp" className="timeline-logo" />}
            >
              <h3 className="vertical-timeline-element-title">Master of Information</h3>
              <h4 className="vertical-timeline-element-subtitle">University of Michigan, Ann Arbor</h4>
              <p>
                Human Computer Interaction Specialization, Merit Scholarship
              </p>

            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--education"
              date="2010 - 2014"
              iconStyle={{ background: '#ffffff', color: '#000' }}
              icon={<img src="./assets/img/homepage/whu-logo.webp" className="timeline-logo" />}
            >
              <h3 className="vertical-timeline-element-title">Bachelor of Information Management</h3>
              <h4 className="vertical-timeline-element-subtitle">Wuhan University</h4>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--no-content"
              iconStyle={{ background: '#ffffff', color: '#000' }}
              icon={<img src="./assets/img/homepage/fly.gif" className="timeline-logo icf-next-logo" />}
            />
          </VerticalTimeline>

          <style>{`
            .timeline-section {
              background: #000000;
              background: radial-gradient(circle at center, #2c3e50 0%, #000000 100%);
              padding: 100px 0;
              position: relative;
              overflow: hidden;
              margin-top: -100px;
              padding-top: 200px;
            }

            .vertical-timeline::before {
              background: rgba(255, 255, 255, 0.15) !important;
              width: 2px !important;
            }

            .vertical-timeline-element-content {
              background: rgba(255, 255, 255, 0.12) !important;
              backdrop-filter: blur(20px);
              -webkit-backdrop-filter: blur(20px);
              border: 1px solid rgba(255, 255, 255, 0.25) !important;
              box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5) !important;
              border-radius: 20px !important;
              padding: 2em !important;
              transition: background 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), border-color 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
            }

            /* Hide panel for the last element */
            .vertical-timeline-element--no-content .vertical-timeline-element-content {
              display: none !important;
            }

            .vertical-timeline-element-content:hover {
              background: rgba(255, 255, 255, 0.18) !important;
              transform: translateY(-5px) scale(1.02) !important;
              border-color: rgba(33, 150, 243, 0.7) !important;
              box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6) !important;
            }

            .vertical-timeline-element-content-inner {
              background: transparent !important;
              box-shadow: none !important;
              padding: 0 !important;
              border-radius: 0 !important;
            }

            .vertical-timeline-element-title {
              color: #ffffff !important;
              font-family: 'Space Grotesk', sans-serif;
              font-weight: 700 !important;
              font-size: 1.5rem !important;
              margin-bottom: 0.5rem !important;
            }

            .vertical-timeline-element-subtitle {
              margin-top: 0 !important;
              margin-bottom: 1.5rem !important;
              color: #ffffff !important;
            }

            .vertical-timeline-element-subtitle a,
            .award-item strong a,
            .award-item ul li a {
              color: #2196F3 !important;
              font-weight: 600 !important;
              text-decoration: none !important;
              transition: color 0.3s ease;
            }

            .vertical-timeline-element-subtitle a:hover,
            .award-item strong a:hover,
            .award-item ul li a:hover {
              color: #64b5f6 !important;
            }

            .vertical-timeline-element-content p,
            .timeline-job-description {
              color: #ffffff !important;
              line-height: 1.6 !important;
              font-size: 1rem !important;
              opacity: 0.95;
              margin-bottom: 1.5rem !important; /* Spacing between paragraph and list/award bullets */
            }

            .vertical-timeline-element-date {
              color: #ffffff !important;
              font-weight: 600 !important;
              font-size: 1.1rem !important;
              opacity: 0.8 !important;
            }

            @media only screen and (min-width: 1170px) {
              .vertical-timeline-element--split .vertical-timeline-element-content {
                background: transparent !important;
                border: none !important;
                box-shadow: none !important;
                padding: 0 !important;
              }

              .vertical-timeline-element--split .vertical-timeline-element-content-inner {
                background: rgba(255, 255, 255, 0.12) !important;
                backdrop-filter: blur(20px);
                -webkit-backdrop-filter: blur(20px);
                border: 1px solid rgba(255, 255, 255, 0.25) !important;
                border-radius: 20px !important;
                padding: 2em !important;
                box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5) !important;
              }

              .vertical-timeline-element--split .vertical-timeline-element-date {
                background: rgba(255, 255, 255, 0.12) !important;
                backdrop-filter: blur(20px);
                -webkit-backdrop-filter: blur(20px);
                border: 1px solid rgba(255, 255, 255, 0.25) !important;
                border-radius: 20px !important;
                padding: 2em !important;
                box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5) !important;
                left: 122% !important;
                width: 100% !important;
                top: 0 !important;
                margin: 0 !important;
                display: block !important;
              }

              .vertical-timeline-element--split .vertical-timeline-element-date::before {
                border-right-color: rgba(255, 255, 255, 0.25) !important;
              }
            }

            .awards-container {
              margin-top: 0 !important;
            }

            .award-item span {
              color: #ffffff !important;
              font-size: 0.95rem !important;
              opacity: 0.95;
            }

            .award-item strong {
              color: #ffffff !important;
            }

            .clients.border {
              border: 1px solid rgba(255, 255, 255, 0.2) !important;
              background: #ffffff !important; /* Forced white background for award bullets */
            }

            .award-bullet {
              width: 40px;
              height: 40px;
              object-fit: contain;
              background: #ffffff !important;
            }

            blockquote {
              background: rgba(33, 150, 243, 0.08) !important;
              border-left: 4px solid #2196F3 !important;
              padding: 1.5em !important;
              margin: 2em 0 !important;
              border-radius: 0 15px 15px 0 !important;
            }

            .timeline-blockquote {
              color: #ffffff !important;
              font-style: italic !important;
              line-height: 1.6 !important;
              opacity: 0.95;
            }

            blockquote span {
              color: #2196F3 !important;
              display: block;
              margin-top: 1rem;
              font-style: normal;
              font-weight: 600;
              font-size: 0.9rem;
            }

            .vertical-timeline-element-icon {
              background: #ffffff !important; /* Forced white background for timeline dots */
              box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.1), inset 0 2px 0 rgba(0,0,0,.08), 0 3px 0 4px rgba(0,0,0,0.05) !important;
            }

            .timeline-logo {
              filter: none !important;
              opacity: 1 !important;
            }
            
            .vertical-timeline-element-content-arrow {
              border-right-color: rgba(255, 255, 255, 0.25) !important;
            }
          `}</style>
        </section>
      )
    }
  }
  
  export default LandingTimeline;
